import { GeneratedComplaint, Tone } from "../types";

export const generateComplaint = async (
  senderName: string,
  company: string,
  incidentDate: string,
  description: string,
  tone: Tone,
  compensationLevel: number,
  imageBase64?: string,
  imageMimeType?: string
): Promise<GeneratedComplaint> => {

  return postGenerate({
    senderName,
    company,
    incidentDate,
    description,
    tone,
    compensationLevel,
    imageBase64,
    imageMimeType
  });
};

// Shared by both modes; the deposit form sends its own fields plus kind: 'deposit'.
export const postGenerate = async (payload: Record<string, unknown>): Promise<GeneratedComplaint> => {
  const response = await fetch('/api/generate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    console.error("API Error:", errorData);
    throw new Error(errorData.error || 'Failed to generate complaint');
  }

  const data = await response.json();
  return data as GeneratedComplaint;
};
